//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/iron-ajax";
import Alodokter from "../../../../utils/Alodokter";

import { _webinarStatusLabel, _isShowPrice, _isStrikethroughPrice, _sponsoreChannelCategory, _sponsoreChannelName, _sponsoreChannelLogo, _isWebinarSeriesLanding, _isShowSponsoreChannel, _isWebinarLiveOrFinished, _isUserRegistered, _isWebinarPublishorPaidFinished, _getQueryParamPagination, _webinarEventStatus } from "../../../../utils/Webinar";

import { _checkSkpPoint } from "../../../../utils/skp";
import GeneralUtils from "../../../../utils/General";

import "../../shared/ModalShare";
import "../../shared/ToastNotification";

import skp from "images/icons/icon_skp_point.svg";
import share from "images/icons/icon_share_grey.svg";
import calendar from "images/icons/icon_calendar_grey.svg";
import webinar_series from "images/icons/icon_webinar_series.svg";
import success from "images/icons/icon_check_white.svg";
import play from "images/icons/icon_play.svg";

import "./WebinarCard.style";
import WebinarAnalytics from "../../../../analytics/WebinarAnalytics";

class WebinarCard extends PolymerElement {
  static get template() {
    return html`
      <style include="webinar-card-style"></style>
      <iron-ajax id="_registerBtn" method="POST" url="/api/general/webinars/register" handle-as="json" on-response="_handleRegisterResponse" debounce-duration="300"> </iron-ajax>
      <div class="item-webinar-container" id="webinar-card-container" on-click="_goToWebinarDetail">
        <div class="thumbnail-webinar">
          <img src="[[webinarItem.webinar_content.thumbnail]]" />
          <div class$="webinar-status-container {{_webinarStatusLabel(webinarItem)}}">{{webinarItem.webinar_content.broadcast_status_text}}</div>
        </div>
        <div class="detail-webinar">
          <div>
            <dom-if if="{{_isShowSponsoreChannel(webinarItem)}}">
              <template>
                <div class="sponsore-channel-container">
                  <img src="[[_sponsoreChannelLogo(webinarItem)]]" />
                  <div class="sponsore-channel-title">
                    <p class="sponsore-category">{{_sponsoreChannelCategory(webinarItem)}}</p>
                    <p class="sponsore-name">{{_sponsoreChannelName(webinarItem)}}</p>
                  </div>
                </div>
              </template>
            </dom-if>
            <div class="description-webinar">
              <div class="webinar-schdule-continer">
                <dom-if if="{{_isWebinarSeriesLanding(webinarItem)}}">
                  <template>
                    <div class="webinar-series-indicator">
                      <img src="[[iconWebinarSeries]]" />
                      <p>{{webinarItem.webinar_content.total_session}}</p>
                      <hr class="line-grey" />
                    </div>
                  </template>
                </dom-if>
                <p class="webinar-schdule">{{webinarItem.webinar_content.broadcast_time}}</p>
              </div>
              <h2 class="webinar-title">{{webinarItem.webinar_content.title}}</h2>
              <div class="webinar-skp-price-container">
                <template is="dom-if" if="{{_checkSkpPoint(webinarItem.webinar_content.skp_point)}}">
                  <div class="skp-point-container">
                    <img src="[[iconSkpPoint]]" />
                    <span class="skp-point">+{{formattedSkpPoint(webinarItem.webinar_content.skp_point)}} SKP</span>
                  </div>
                </template>
                <template is="dom-if" if="{{_isShowPrice(webinarItem)}}">
                  <template is="dom-if" if="{{isLogin}}">
                    <template is="dom-if" if="{{_isStrikethroughPrice(webinarItem)}}">
                      <p>Harga {{webinarItem.webinar_content.payment_info.normal_price}} <span class="strikethrough-price">{{webinarItem.webinar_content.payment_info.base_price}}</span></p>
                    </template>
                    <template is="dom-if" if="{{!_isStrikethroughPrice(webinarItem)}}">
                      <p>Harga {{webinarItem.webinar_content.payment_info.normal_price}}</p>
                    </template>
                  </template>
                  <template is="dom-if" if="{{!isLogin}}">
                    <p>Harga {{webinarItem.webinar_content.payment_info.base_price}}</p>
                  </template>
                </template>
              </div>
            </div>
          </div>
          <div class="webinar-share-register">
            <div class="webinar-share-button" on-click="_handleClickShare">
              <img src="[[iconShare]]" />
              <p class="webinar-share-button-text">Bagi</p>
            </div>
            <dom-if if="{{_isWebinarPublishorPaidFinished(webinarItem, isRegistered)}}">
              <template>
                <div type="button" class="webinar-register-button" on-click="_registerBtnHandler">
                  <img src="[[iconCalendar]]" />
                  <p>&nbsp Daftar</p>
                </div>
              </template>
            </dom-if>
            <dom-if if="{{_isWebinarLiveOrFinished(webinarItem, isRegistered)}}">
              <template>
                <div class="webinar-watch-button" on-click="_registerBtnHandler">
                  <img src="[[iconPlay]]" />
                  <p>&nbsp Tonton</p>
                </div>
              </template>
            </dom-if>
            <dom-if if="{{!_isUserRegistered(webinarItem, isRegistered)}}">
              <template>
                <div class="webinar-registered-button">
                  <img src="[[iconSuccess]]" />
                  <p>&nbsp Terdaftar</p>
                </div>
              </template>
            </dom-if>
          </div>
        </div>
        <modal-share id="modalRegister" webinar-id="{{webinarItem.id}}" webinar-title="{{webinarItem.webinar_content.title}}" is-active="{{modalShare}}" webinar-type="{{webinarItem.webinar_content.type}}"> </modal-share>
        <toast-notification id="isShowModalSuccess" title="Kami akan memberi tahu Anda kembali pada hari acara" title-bold="'{{webinarItem.webinar_content.title}}.'" is-active="{{isShowModalSuccess}}"> </toast-notification>
      </div>
    `;
  }

  static get properties() {
    return {
      iconSkpPoint: {
        type: String,
        value: skp,
      },

      iconShare: {
        type: String,
        value: share,
      },

      iconCalendar: {
        type: String,
        value: calendar,
      },

      iconSuccess: {
        type: String,
        value: success,
      },

      iconPlay: {
        type: String,
        value: play,
      },

      iconWebinarSeries: {
        type: String,
        value: webinar_series,
      },

      webinarItem: {
        type: Object,
      },

      response: {
        type: Object,
        value: {},
      },

      responseMessage: {
        type: Boolean,
        value: true,
      },

      modalShare: {
        type: Boolean,
        value: false,
      },

      isShowModalSuccess: {
        type: Boolean,
        value: false,
      },

      isRegistered: {
        type: Boolean,
      },

      userUid: {
        type: String,
      },

      isLogin: {
        type: Number,
      },

      _webinarStatusLabel: {
        type: Function,
        value: () => _webinarStatusLabel,
      },

      _isShowPrice: {
        type: Function,
        value: () => _isShowPrice,
      },

      _isStrikethroughPrice: {
        type: Function,
        value: () => _isStrikethroughPrice,
      },

      _sponsoreChannelCategory: {
        type: Function,
        value: () => _sponsoreChannelCategory,
      },

      _sponsoreChannelName: {
        type: Function,
        value: () => _sponsoreChannelName,
      },

      _sponsoreChannelLogo: {
        type: Function,
        value: () => _sponsoreChannelLogo,
      },

      _isWebinarSeriesLanding: {
        type: Function,
        value: () => _isWebinarSeriesLanding,
      },

      _isShowSponsoreChannel: {
        type: Function,
        value: () => _isShowSponsoreChannel,
      },

      _isWebinarLiveOrFinished: {
        type: Function,
        value: () => _isWebinarLiveOrFinished,
      },

      _isUserRegistered: {
        type: Function,
        value: () => _isUserRegistered,
      },

      _isWebinarPublishorPaidFinished: {
        type: Function,
        value: () => _isWebinarPublishorPaidFinished,
      },
      _getQueryParamPagination: {
        type: Function,
        value: () => _getQueryParamPagination,
      },
      _webinarEventStatus: {
        type: Function,
        value: () => _webinarEventStatus,
      },
      _checkSkpPoint: {
        type: Function,
        value: () => _checkSkpPoint,
      },
      formattedSkpPoint: {
        type: Function,
        value: () => GeneralUtils.formattedSkpPoint,
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    const observerOptions = {
      rootMargin: '-120px 0px 0px 0px'
    }
    this._loadObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio !== 0 && !this.isImpression) {
        this.isImpression = true;
        this.dispatchEvent(new CustomEvent("tracking-impression-load", { detail: this.webinarItem }));
      }
    }, observerOptions);
    this._loadObserver.observe(this.shadowRoot.querySelector("#webinar-card-container"));
    window.addEventListener("load", function() {
      this._loadObserver.unobserve(this.shadowRoot.querySelector("#webinar-card-container"));
      window.addEventListener("scroll", function() {
        this._scrollObserver = new IntersectionObserver((entries) => {
          if (entries[0].intersectionRatio !== 0 && !this.isImpression) {
            this.isImpression = true;
            this.dispatchEvent(new CustomEvent("tracking-impression-scroll", { detail: this.webinarItem }));
          }
        }, observerOptions);
        this._scrollObserver.observe(this.shadowRoot.querySelector("#webinar-card-container"));
      }.bind(this));
    }.bind(this));
  }

  ready() {
    super.ready();
    if (this.webinarItem) {
      this.isRegistered = this.webinarItem.webinar_content.is_registered;
    }
  }

  _goToWebinarDetail(e) {
    var target = e.target;
    this.sendGAWebinarCardClicked();
    WebinarAnalytics.selectItem(this.webinarItem, 'card_area'); //GA4
    if (target != this.$.modalRegister && target != this.$.isShowModalSuccess) {
      return (window.location = window.location.origin + window.location.pathname + "/" + this.webinarItem.slug + "?type=" + this.webinarItem.webinar_content.type);
    }
  }

  _registerBtnHandler(e) {
    e.stopPropagation();
    let finished = "finished";
    let live = "live";
    let publish = "publish";
    var paidWebinar = (this.webinarItem.webinar_content.is_paid_webinar && this.webinarItem.webinar_content.broadcast_status == publish) || this.webinarItem.webinar_content.broadcast_status == live || this.webinarItem.webinar_content.broadcast_status == finished;
    var webinarFreeAndPublish = !this.webinarItem.webinar_content.is_paid_webinar && this.webinarItem.webinar_content.broadcast_status == publish;
    var webinarFreeAndLiveOrFinished = (!this.webinarItem.webinar_content.is_paid_webinar && this.webinarItem.webinar_content.broadcast_status == finished) || this.webinarItem.webinar_content.broadcast_status == live;
    this.sendGAWebinarCardRegisterOrWatch();
    // PAID WEBINAR
    if (paidWebinar) {
      if (!this.isLogin) {
        return $("#entrance-overlay").css("display", "block");
      } else {
        WebinarAnalytics.selectItem(this.webinarItem, 'tonton'); //GA4
        return (window.location = window.location.origin + window.location.pathname + "/" + this.webinarItem.slug + "?type=" + this.webinarItem.webinar_content.type);
      }
    }

    // FREE WEBINAR
    if (webinarFreeAndPublish) {
      WebinarAnalytics.addToCart({
        id: this.webinarItem.id, 
        is_paid_webinar: this.webinarItem.webinar_content.is_paid_webinar, 
        title: this.webinarItem.webinar_content.title,
        type: this.webinarItem.webinar_content.type
      }, 'webinar_landing');
      var registerUser = { id: this.webinarItem.id, user_uid: this.userUid };
      this.$._registerBtn.params = registerUser;
      this.$._registerBtn.generateRequest();
    } else if (webinarFreeAndLiveOrFinished) {
      return (window.location = window.location.origin + window.location.pathname + "/" + this.webinarItem.slug + "?type=" + this.webinarItem.webinar_content.type);
    }
  }

  _handleRegisterResponse(e) {
    var response = e.detail.response;
    this.response = response;

    if (this.response.status == 200) {
      this.isRegistered = true;
      this.isShowModalSuccess = true;
    } else if (this.response.status == 500) {
      null;
    } else {
      if (!response.isEmailValid) {
        $("#entrance-overlay").css("display", "block");
      }
    }
  }

  _handleClickShare(e) {
    e.stopPropagation();
    this.modalShare = true;
  }

  getTrackingUserUid() {
    return this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
  }

  sendGAWebinarCardRegisterOrWatch() {
    var isRegister = this._isWebinarPublishorPaidFinished(this.webinarItem, this.isRegistered);
    var isWatchWebinar = this._isWebinarLiveOrFinished(this.webinarItem, this.isRegistered);
    if (isRegister) {
      this.sendGAWebinarCardRegisterClicked();
    }
    if (isWatchWebinar) {
      this.sendGAWebinarCardWatchClicked();
    }
  }

  sendGAWebinarCardClicked() {
    const userUid = this.getTrackingUserUid();
    const webinar = this.webinarItem.webinar_content;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarStatus = this._webinarEventStatus(webinar);
    const webinarPagePosition = this._getQueryParamPagination();
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free";
    const userRegisterStatus = webinar.is_registered ? "registered" : "not_registered";
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_type: ${webinarType} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | user_register_status: ${userRegisterStatus} | pagination_position: ${webinarPagePosition} | device_category: desktop`;
    Alodokter.sendEventGA("webinar landing page", "webinar_card_clicked", eventLabel);
  }

  sendGAWebinarCardRegisterClicked() {
    const userUid = this.getTrackingUserUid();
    const webinar = this.webinarItem.webinar_content;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarStatus = this._webinarEventStatus(webinar);
    const webinarPagePosition = this._getQueryParamPagination();
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free";
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_type: ${webinarType} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | pagination_position: ${webinarPagePosition} | device_category: desktop`;
    Alodokter.sendEventGA("webinar landing page", "webinar_register_button_clicked", eventLabel);
  }

  sendGAWebinarCardWatchClicked() {
    const userUid = this.getTrackingUserUid();
    const webinar = this.webinarItem.webinar_content;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarStatus = this._webinarEventStatus(webinar);
    const webinarPagePosition = this._getQueryParamPagination();
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free";
    const userRegisterStatus = webinar.is_registered ? "registered" : "not_registered";
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_type: ${webinarType} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | user_register_status: ${userRegisterStatus} | pagination_position: ${webinarPagePosition} | device_category: desktop`;
    Alodokter.sendEventGA("webinar landing page", "webinar_watch_button_clicked", eventLabel);
  }
}
customElements.define("webinar-card", WebinarCard);
